import { type ButtonHTMLAttributes, type ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "ghost" | "accent";
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  iconOnly?: boolean;
}

// Background + hover in Tailwind classes (inline style overrides :hover, so bg must be here)
const variantClass: Record<string, string> = {
  primary: "bg-primary text-white hover:brightness-110",
  ghost:   "bg-transparent text-[#1A1D1F] hover:bg-black/[0.08]",
  accent:  "bg-[#FF7900] text-white hover:brightness-110",
};

export function Button({
  children,
  variant = "primary",
  leftIcon,
  rightIcon,
  iconOnly = false,
  className = "",
  style,
  ...props
}: ButtonProps) {
  const baseStyle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    cursor: "pointer",
    borderRadius: 12,
    border: "none",
    fontFamily: "var(--font-commissioner)",
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: 16,
    lineHeight: "20px",
    whiteSpace: "nowrap",
    ...(iconOnly
      ? { padding: 10 }
      : { padding: "10px 16px", gap: leftIcon || rightIcon ? 8 : 0 }),
    ...style,
  };

  return (
    <button
      className={`transition-[filter,background-color] duration-150 ${variantClass[variant]} ${className}`}
      style={baseStyle}
      {...props}
    >
      {leftIcon && <span style={{ width: 20, height: 20, flexShrink: 0 }}>{leftIcon}</span>}
      {children}
      {rightIcon && <span style={{ width: 20, height: 20, flexShrink: 0 }}>{rightIcon}</span>}
    </button>
  );
}
